import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { useDescriptionListContext } from "./DescriptionListContext";
import { DescriptionProps } from "./types";
import ValueRenderer from "./DescriptionValue";
import { cn } from "@/lib/utils";
import { Button } from "../ui/button";
import { generatePath, Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

interface DescriptionItemProps extends DescriptionProps {
  className?: string;
  linkClassName?: string;
  to: string;
}

const DescriptionLink = ({
  name,
  renderer,
  className,
  linkClassName,
  to,
}: DescriptionItemProps) => {
  const { t } = useTranslation();
  const { translationKey, data } = useDescriptionListContext();
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <Label className="text-sm font-medium">
        {t(`${translationKey}.fields.${name}`)}
      </Label>
      <span className="text-sm text-muted-foreground flex items-center gap-2">
        <Button variant="outline" className="font-bold" asChild>
          <Link
            to={generatePath(to, {
              id: data?.id,
            })}
            className={linkClassName}
          >
            <span className="truncate">
              <ValueRenderer
                value={data?.[name] as string}
                renderer={renderer}
              />
            </span>
            <ExternalLink className="w-4 h-4" />
          </Link>
        </Button>
      </span>
    </div>
  );
};

export default DescriptionLink;
